import request from '@/utils/request'
// 获取会议数量
const getMeetingCount = (params) => {
    return request({
        url: `/gathering/meeting/count`,
        params,
        method: 'get'
    })
}
// 获取会议列表
const getMeetingList = (params) => {
    return request({
        url: `/gathering/meeting/list`,
        params,
        method: 'get'
    })
}
// 新增会议
const addMeeting = (params) => {
    return request({
        url: `/gathering/meeting`,
        method: 'post',
        data: params
    })
}
// 获取会议详情
const getMeetingDetail = (id) => {
    return request({
        url: `/gathering/meeting/${id}`,
        method: 'get'
    })
}
// 修改会议详情
const editMeeting = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}`,
        method: 'put',
        data: params
    })
}
// 修改会议流
const editMeetingFlow = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/live`,
        method: 'put',
        data: params
    })
}
// 删除会议
const deleteMeeting = (params) => {
    return request({
        url: `/gathering/meeting/batch`,
        method: 'delete',
        data: params
    })
}
// 开始正式会议
const beginMeeting = (id) => {
    return request({
        url: `/gathering/meeting/${id}/began`,
        method: 'put'
    })
}
// 结束会议
const endMeeting = (id) => {
    return request({
        url: `/gathering/meeting/${id}/ended`,
        method: 'put'
    })
}
// 开始测试会议
const testMeeting = (id) => {
    return request({
        url: `/gathering/meeting/${id}/test`,
        method: 'put'
    })
}
// 重开会议
const restartMeeting = (id) => {
    return request({
        url: `/gathering/meeting/${id}/reBegan`,
        method: 'put'
    })
}
// 获取参会人情况
const getAttendSituation = (id) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/attendance`,
        method: 'get'
    })
}
// 提交回复
const AddReply = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/question/reply`,
       method: 'post',
       data: params
    })
}
// 会议存证查询
const getMeetingRecord = (id) => {
    return request({
        url: `gathering/meeting/${id}/get_file_evidence`,
        method: 'get'
    })
}
export {
    getMeetingCount,
    getMeetingList,
    addMeeting,
    getMeetingDetail,
    editMeeting,
    deleteMeeting,
    beginMeeting,
    endMeeting,
    editMeetingFlow,
    testMeeting,
    getAttendSituation,
	AddReply,
	getMeetingRecord,
    restartMeeting
}